import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  /** One sentence: why it is empty and what filling it gets you. */
  body?: string;
  /** The single next step. */
  action?: React.ReactNode;
  className?: string;
  compact?: boolean;
}

/** Every empty view says what to do next. Never a bare "No items". */
export function EmptyState({ icon: Icon, title, body, action, className, compact }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center text-center',
        compact ? 'px-5 py-8' : 'px-6 py-12',
        className
      )}
    >
      {Icon && (
        <span className={cn('sfx-icon-tile mb-3', compact ? 'h-9 w-9' : 'h-11 w-11')}>
          <Icon className={compact ? 'h-4 w-4' : 'h-5 w-5'} strokeWidth={2} />
        </span>
      )}
      <p className="font-display text-sm font-semibold text-foreground">{title}</p>
      {body && (
        <p className="mt-1 max-w-[34ch] text-xs leading-relaxed text-muted-foreground text-pretty">
          {body}
        </p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
